import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Divider } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from './services/auth';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await authService.signIn(values.email, values.password);
      message.success('登录成功');
      navigate('/dashboard');
    } catch (error) {
      message.error(error.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <Card title="用户登录" style={{ width: 400 }}>
        <Form
          name="login"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            label="邮箱"
            name="email"
            rules={[{ required: true, message: '请输入邮箱' }, { type: 'email', message: '请输入有效的邮箱地址' }]}
          >
            <Input placeholder="请输入邮箱" />
          </Form.Item>

          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password placeholder="请输入密码" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%' }}>
              登录
            </Button>
          </Form.Item>

          <Divider>
            还没有账号？
          </Divider>

          <Form.Item>
            <Button type="default" style={{ width: '100%' }}>
              <Link to="/register">立即注册</Link>
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
